export default {
    packages_features_title: "Features",
    packages_features_success_message: "Features have been updated",
    packages_features_error_message: "It was not possible to update the features due to an error",
    packages_features_feature_name: "Feature Name",
    packages_features_feature_key: "Feature Key",
    packages_features_read: "Read",
    packages_features_create: "Create",
    packages_features_update: "Update",
    packages_features_delete: "Delete",
    packages_features_optional: "Optional",
    packages_features_default: "Default",
    packages_features_save_changes: "Save Changes",
    packages_features_all: "All",
    packages_features_the_feature_mush_have_the_read: "The feature must have the read permission checked",
    packages_features_all_features_must_have_read_permission_check: "All features must have read permission checked",
    packages_features_group_name: "Group Name",
    packages_features_category: "Category",
    packages_features_main_feature_read_perm: "The main feature must have read permissions",
    packages_features_main_feature_create_perm: "The main feature must have create permissions",
    packages_features_main_feature_update_perm: "The main feature must have update permissions",
    packages_features_main_feature_delete_perm: "The main feature must have delete permissions",
    packages_features_the_group_must_be_included: "The group must be included",
    packages_features_group: "Group",
    packages_features_included: "Included",
    packages_features_code: "Code",
    packages_features_description: "Description",
    packages_features_active: "Active",
}